import React, { Component } from 'react';
import './private-link-user.scss';
import Select from 'react-select';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { change } from 'redux-form';
import connect from 'react-redux/es/connect/connect';
import { renderField, validate } from '../form/utils';

import {
  privateLinkUser,
  getPrivateLinkUser,
  updateUrlStatus,
  deleteUrl,
} from '../../actions/privateUrls';
import { toastr } from 'react-redux-toastr';
import { MESSAGES, TABS } from '../../utils/strings';
import { changeTab } from '../../actions/tab';
import { ColumnConfig, WPReTable } from 'wp-react-toolkits/dist-es6';
import Immutable from 'immutable';
import UI_Utils from '../../utils/ui';
import PDABaseClass from '../abstract';

import FixRequiredSelect from "../abstract/required-select.js";
const RequiredSelect = props => (
    <FixRequiredSelect
        {...props}
        SelectComponent={Select}
        options={props.options || options}
    />
);

class PrivateLinkUser extends PDABaseClass {
  constructor (props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.renderTableTab = this.renderTableTab.bind(this);
    this.state = {
      selectedRoles: [],
      loadingData: false,
    };
    this.wpData = {
      isLicenseExpired: window.pda_gold_v3_data.is_license_expired,
    };
  }

  handleChangeRolesSelected = (selectedRoles) => {
    this.setState(prevState => ({ ...prevState, selectedRoles }));
  };

  render () {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    const { selectedRoles } = this.state;
    const roles = ip_block_server_data.roles.map((role) => {
      return {
        label: role,
        value: role,
      };
    });

    const form = (
      <div className="pda_wrap_private_link_user">
        <form className="pda_wrap_form_private_link_user"
              onSubmit={handleSubmit(this.onSubmit)}>
          <p>
            <p className="pda_label_user_role">User roles</p>
            <RequiredSelect
              className="pda_user_roles_popup"
              options={roles}
              value={selectedRoles}
              placeholder="Select user access"
              onChange={this.handleChangeRolesSelected}
              isMulti
              required
            />
          </p>
          <Field name="private_link_user_limit_downloads" type="number"
                 component={renderField}
                 label="Download limit (leave blank for unlimited re-downloads)"
                 className="pda-input-field"/>
          <Field name="private_link_user_expired_days" type="number"
                 component={renderField}
                 label="Download expiry (enter the number of days before this download link expires, or leave blank)"
                 className="pda-input-field"/>
          <div className="pup-actions">
            <button
              disabled={submitting || this.wpData.isLicenseExpired}
              className="btn button action" type="submit">Save
            </button>
          </div>
        </form>
        {this.renderTableTab()}
      </div>
    );
    return this.state.loadingData ? this.renderLoading() : form;
  }

  renderTableTab () {
    const { privateLinkUserData } = this.props;
    if (privateLinkUserData.data_private_link) {
      const dataPrivateLink = [privateLinkUserData.data_private_link];
      const data = Immutable.List(dataPrivateLink);
      const configs = {
        columnsConfig: [
          new ColumnConfig('Shared Private Link', 'full_url', false, 1200,
            ({ cellData, rowData }) => {
              return <a target="_blank" href={cellData}>{cellData}</a>;
            }),

          new ColumnConfig('Is it active?', 'is_prevented', false, 300,
            ({ cellData }) => {
              return cellData == 1 ?
                <i className='fa fa-check fa-lg pda-active-link '/>
                : <i className='fa fa-times fa-lg pda-inactive-link'/>;
            }),

          new ColumnConfig('Created Time', 'time', true, 500,
            ({ cellData }) => {
              return new Date(cellData * 1000).toLocaleString();
            }),

          new ColumnConfig('', 'ID', true, 250, ({ cellData, rowData }) => {
            const { ID } = rowData;
            const changeStatusLabel = rowData.is_prevented === '1'
              ? 'De-activate'
              : 'Activate';
            return (
              <div>
                            <span title="Copy to clipboard"
                                  onClick={this.handleCopyPrivateLinkUser.bind(
                                    this)}
                                  className="pdav3_table_actions">
                              <i className="fa fa-copy fa-lg"/>
                            </span>
                <span title={changeStatusLabel}
                      onClick={this.handleSetLinkUserStatus.bind(this, ID,
                        rowData.is_prevented)}
                      className="pdav3_table_actions"><i
                  className="fa fa-chain-broken fa-lg"></i>
                            </span>
                <span title="Delete link"
                      onClick={this.handleDeletePrivateLinkUser.bind(this,
                        cellData)}
                      className="pdav3_table_actions">
                              <i className="fa fa-remove fa-lg"/>
                            </span>
              </div>
            );
          }),

        ],
      };

      return (<div className="pda_wrap_table_private_link_user">
        <hr/>
        <WPReTable list={data} config={configs} customStyle={{ height: 90 }}/>
      </div>);
    }
  }

  handleCopyPrivateLinkUser () {
    const { privateLinkUserData } = this.props;
    const link = privateLinkUserData.data_private_link.full_url;
    UI_Utils.handleCopyBtn(link);
  }

  handleSetLinkUserStatus (id, is_prevented) {
    const { updateUrlStatus } = this.props;
    is_prevented = is_prevented === '1' ? true : false;
    this.showLoading();
    updateUrlStatus(id, is_prevented).then(() => {
      const { updateUrlResponse } = this.props;
      if (updateUrlResponse.result.isError) {
        toastr.error(MESSAGES.ERR_UPDATE_PRIVATE_LINK);
      } else {
        this.refreshData();
        toastr.success(MESSAGES.UPDATE_LINK_DATA);
      }
      this.hideLoading();
    });
  }

  handleDeletePrivateLinkUser (id) {
    const toastrConfirmOptions = {
      onOk: () => {
        const { deleteUrl } = this.props;
        deleteUrl(id).then(() => {
          const { deleteUrlResponse } = this.props;
          if (deleteUrlResponse.result.isError) {
            toastr.error(MESSAGES.ERR_DELETE_PRIVATE_LINK);
          } else {
            this.props.change('private_link_user_limit_downloads', '');
            this.props.change('private_link_user_expired_days', '');
            this.setState(prevState => ({
              ...prevState,
              selectedRoles: [],
            }));
            this.refreshData();
            toastr.success(MESSAGES.DELETE_PRIVATE_LINK);
          }
        });
      },
      okText: 'Yes',
      cancelText: 'No',
    };
    toastr.confirm(MESSAGES.CONFIRM_DELETE_LINK, toastrConfirmOptions);
  }

  renderLoading () {
    return (
      <div className="loading">Loading Data...</div>
    );
  }

  refreshData () {
    const { getPrivateLinkUser, postId } = this.props;
    this.showLoading();
    getPrivateLinkUser(postId).then(() => {
      const { privateLinkUserData } = this.props;
      if (privateLinkUserData.data_private_link) {
        this.props.change('private_link_user_limit_downloads',
          privateLinkUserData.data_private_link.limit_downloads);
        this.props.change('private_link_user_expired_days',
          privateLinkUserData.data_private_link.expired_date);
        const roles = privateLinkUserData.data_private_link.roles.split(';').
          map((role) => {
            return {
              label: role,
              value: role,
            };
          });
        this.setState(prevState => ({
          ...prevState, selectedRoles: roles,
        }));
      }
      this.hideLoading();
    });
  }

  componentWillMount () {
    this.refreshData();
    const { postId, getPrivateLinkUser } = this.props;
    getPrivateLinkUser(postId);
  }

  onSubmit (values) {
    const roles = this.state.selectedRoles.map((data) => {
      return data.value;
    });
    if (roles.length > 0) {
      values.selectedRoles = roles.join(';');
    }
    const { privateLinkUser, postId } = this.props;
    privateLinkUser(postId, values).then(() => {
      const { createdUrl } = this.props;
      if (createdUrl.isError) {
        toastr.error(
          'Opps! Unable to create new custom private link due to duplicate slug.');
      } else {
        this.refreshData();
        toastr.success(MESSAGES.CREATE_NEW_PRIVATE_LINK);
      }
    });
  }
}

const Form = reduxForm({
  form: 'PrivateLinkUser',
    validate
})(PrivateLinkUser);

const mapStateToProps = state => {
  return {
    createdUrl: state.createUrls,
    privateLinkUserData: state.privateLinkUser,
    updateUrlResponse: state.updateUrl,
    deleteUrlResponse: state.deleteUrl,
  };
};

const mapActionsToProps = (dispatch) => {
  return bindActionCreators({
    privateLinkUser,
    changeTab,
    getPrivateLinkUser,
    updateUrlStatus,
    deleteUrl,
  }, dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(Form);
